import { render, staticRenderFns } from "./AppSiderbar.vue?vue&type=template&id=a7d4ddb0&scoped=true&"
import script from "./AppSiderbar.vue?vue&type=script&lang=js&"
export * from "./AppSiderbar.vue?vue&type=script&lang=js&"
import style0 from "./AppSiderbar.vue?vue&type=style&index=0&id=a7d4ddb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d4ddb0",
  null
  
)

export default component.exports